import { useEffect } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { AssignServiceOrderForm, Modal } from "components";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { GET_SERVICE_ORDER } from "./view";

const ASSIGN_SERVICE_ORDER = gql`
  mutation AssignInstallationServiceOrder(
    $id: ID!
    $assignee: ID!
    $installationMeter: ID!
  ) {
    assignInstallationServiceOrder: assignInstallationServiceOrderMeterContractor(
      id: $id
      assignee: $assignee
      installationMeter: $installationMeter
    ) {
      _id
    }
  }
`;

export default function AssignInstallationServiceOrderContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_SERVICE_ORDER, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
  });
  const [assignReplacementServiceOrder] = useMutation(ASSIGN_SERVICE_ORDER);

  const form = useFormik({
    initialValues: {
      contractorInfo: {
        contractor: null as any,
      },
      contractorUserInfo: {
        contractorUser: null as any,
      },
      meterInfo: {
        meter: null as any,
      },
    },
    onSubmit: async (values) => {
      await assignReplacementServiceOrder({
        variables: {
          id: searchParams.id,
          assignee: values.contractorUserInfo?.contractorUser?._id,
          installationMeter: values.meterInfo?.meter?._id,
        },
      }).then(({ data }) => {
        if (data.assignInstallationServiceOrder._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Service Order Assigned Successfully",
            })
          );
          refetch?.();
          form.resetForm();
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not assign Service Order",
            })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  useEffect(() => {
    form.setValues({
      contractorInfo: {
        contractor:
          data?.installationServiceOrder?.farmingOutContractor || (null as any),
      },
      contractorUserInfo: {
        contractorUser:
          data?.installationServiceOrder?.farmingOutContractorUser ||
          (null as any),
      },
      meterInfo: {
        meter:
          data?.installationServiceOrder?.installationMeter || (null as any),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.installationServiceOrder, searchParams.id, open]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      hideActions={true}
      loading={loading}
      title="Assign Installation Service Order"
      size="5xl"
      description="Provide the details to assign service order"
    >
      {data?.installationServiceOrder?._id && (
        <AssignServiceOrderForm form={form} />
      )}
    </Modal>
  );
}
